import { combineReducers } from 'redux';

import resources from './resources';

export default combineReducers({ resources });
